import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { SiteBrowse } from '@models/interfaces';
import { Details } from '@shared/modules/details';
import { LeasingActions } from '@store/actions';
import { LeasingSelectors } from '@store/selectors';

import './styles.scss';

export const LeasingDetails: FC<RouteComponentProps> = (
  props: PropsWithChildren<RouteComponentProps>,
) => {
  const dispatch = useDispatch();
  const site = useSelector(LeasingSelectors.getLeasingSite);

  useEffect(
    () => (): void => {
      dispatch(LeasingActions.resetTabsData.done(undefined));
    },
    [],
  );

  return (
    <Details
      {...props}
      className="prov-leasing-details"
      fuzeID
      site={site as unknown as SiteBrowse}
    />
  );
};
